import { Outlet } from "react-router-dom";
import { RegionGateway } from "./RegionGateway";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#050505]">
      {/* Combined Fixed Header - Both Region Gateway and Nav together */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black">
        <RegionGateway />
        <Navigation />
      </header>
      {/* Spacer for fixed header */}
      <div className="h-[100px] md:h-[115px]" />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
